<template>  
<div> <!-- root element start -->
    <div class="container-fluid mt-2">

          <div class="row">
            <div class="col-sm-12 col-md-3">
                <div class="card border-0">
                  <div class="card-header h5 bg-transparent border-0">Options</div>
                  <div class="card-body">
                      <ul class="list-group list-group-flush">
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('account-edit', '', '')">Change Account</a>
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('profile-edit', '', '')">Change Profile</a> 
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('password-edit', '', '')">Change Password</a>
                       
                      </ul>
                  </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-9">
              <component :is="rightView" :prop1="prop1" :prop2="prop2" :prop3="prop3"
                @onSComplete="successComplete" 
                @onUComplete="unsuccessComplete" 
                @onSecComplete="onSecondary"
              ></component>
            </div>
           </div>

    </div><!--  end container-fluid div -->
</div> <!-- root element end -->
</template>


<script>
import {store} from '../../stores/settings-store.js'

import accountEdit from '../settingsPageComponents/settings-account-change.vue'
import passwordEdit from '../settingsPageComponents/settings-password-change.vue'
import profileEdit from '../settingsPageComponents/settings-profile-change.vue'

export default {
  props: ['user'],
  store,
  data: function () {
    return { 

    }
  },
  computed: {
    rightView () { return this.$store.state.rightView },
    prop1 () { return this.$store.state.prop1 },
    prop2 () { return this.$store.state.prop2 },
    prop3 () { return this.$store.state.prop3 },
  },
  watch: {
    
  },
  mounted() {
    this.getUserInformation();
    this.getProfileInformation();
  },
  methods: {
    
    changeRightView(name, prop1, prop2) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2 }); },
    getUserInformation() { this.$store.dispatch("getUserInformation"); },
    getProfileInformation() { this.$store.dispatch("getProfileInformation"); },
    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'password-edit':
        _this.changeRightView('', '', '', '');
        break;
        case 'profile-edit':
        // code to run the "get all contacts method" from store
        _this.getProfileInformation();
        _this.changeRightView('profile-edit', '', '', '');
        break;
        case 'account-edit':
        // code to run the "get all contacts method" from store
        _this.getUserInformation();
        _this.changeRightView('account-edit', '', '', '');
        break;
        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'password-edit':
          _this.changeRightView('', '', '', '');
        break;
        case 'profile-edit':
          _this.changeRightView('', '', '', '');
        break;
        case 'account-edit':
          _this.changeRightView('', '', '', '');
        break;

        default:
      }
    },
    onSecondary(value){
      var _this = this;
      switch(value[0]) {
        case 'launchAddContact':
          var setup = ['','',_this.org];
          _this.changeRightView('create-contact', '', '', setup);
        break;
        case 'launchAddQuote':
          var setup = ['','',_this.org];
          _this.changeRightView('create-quote', '', '', setup);
        break;
        case 'launchEditAddress':
          var setup = ['','',value[1]];
          _this.changeRightView('address-edit', '', '', setup);
        break;
        case 'launchEditOrg':
          var setup = ['','',value[1]];
          _this.changeRightView('org-edit', '', '', setup);
        break;
        default:
      }
    },


  },    
  components:{
    'account-edit' : accountEdit,
    'password-edit' : passwordEdit,
    'profile-edit' : profileEdit,
  },
  filters: {

  }
}
</script>
